// src/components/Inbox/SearchBox.js

import React, { useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core'
import {
  toggleContactViewPanel,
  searchConversationsList,
  filterConversationsList,
  listInbox,
  setLoadingAll,
  // filterUserConversationsList,
  toggleHideStopRequests,
  setCursor,
} from 'actions/inbox'
import {
  IconButton,
  Tooltip,
  Menu,
  RadioGroup,
  FormControlLabel,
  Radio,
  // CircularProgress,
  Checkbox,
} from '@material-ui/core'
import { list } from 'actions/data'
import { /* Tune,  */ Search, Cancel } from '@material-ui/icons'
// import { PencilPlus } from 'mdi-material-ui'
import { create, read } from 'actions/data'
import { DATA_API_URL } from 'utils/AllURLs'
import { toggleDialog } from 'actions/view'
import ConversationsListTabs from './ConversationsListTabs'
import Button from 'components/theme/Button'

const styles = theme => ({
  searchBox: {
    borderBottom: '1px solid #e5e5e5',
    height: 60,
    position: 'relative',
    boxShadow:
      '0px 2px 4px rgba(0,0,0,-27.8), 0px 4px 5px rgba(0,0,0,0.05), 0px 1px 10px rgba(0,0,0,-41.88)',
    zIndex: 2,
  },
  textField: {
    backgroundColor: '#fff',
    width: 'calc(100% - 25px)',
    borderRadius: 35,
    padding: '5px 3px 5px 21px',
    height: 22,
    borderWidth: 1,
    position: 'relative',
  },
  input: {
    '&:focus': {
      outline: 'none',
    },
  },
  searchIcon: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    left: 6,
    top: '50%',
    transform: 'translate(0, -50%)',
  },
  moreIconButton: {
    position: 'absolute',
    right: 6,
    top: '50%',
    transform: 'translate(0, -50%)',
  },
  iconButtonRoot: {
    // padding: 0,
  },
  paper: {
    borderRadius: 18,
    border: '1px solid #c3c3c3',
  },
})

export default connect(
  state => ({
    value: state.inbox.conversationsListSearch,
    conversationsListFilter: state.inbox.conversationsListFilter,
    conversationsListUserFilter: state.inbox.conversationsListUserFilter.filter,
    cursor:
      state.inbox.conversationsListCursor[state.inbox.conversationsListFilter]
        ?.cursor,
    loadingAllConversations:
      state.inbox.conversationsListCursor[state.inbox.conversationsListFilter]
        ?.loadingAll,
    vr_role: state.auth.session?.idToken?.payload?.['custom:vr_role'],
    username: state.auth.session?.idToken?.payload?.['cognito:username'],
    read_contacts:
      state.data?.['account/preference']?.preferences?.read_contacts ||
      'anybody',
    users: state.data?.['account/user'],
    userLoadStatus: state.loadStatus.users,
    vr_account_id:
      state.auth?.session?.idToken?.payload?.['custom:vr_account_id'],
    hideStopRequests: state.inbox.hideStopRequests,
  }),
  dispatch =>
    bindActionCreators(
      {
        toggleContactViewPanel,
        searchConversationsList,
        filterConversationsList,
        listInbox,
        setLoadingAll,
        // filterUserConversationsList,
        create,
        read,
        list,
        toggleDialog,
        toggleHideStopRequests,
        setCursor,
      },
      dispatch,
    ),
)(
  withStyles(styles)(
    ({
      classes,
      toggleContactViewPanel,
      value,
      searchConversationsList,
      conversationsListFilter,
      filterConversationsList,
      cursor,
      listInbox,
      setLoadingAll,
      loadingAllConversations,
      vr_role,
      read_contacts,
      // filterUserConversationsList,
      username,
      users,
      conversationsListUserFilter,
      create,
      read,
      vr_account_id,
      list,
      userLoadStatus,
      toggleDialog,
      hideStopRequests,
      toggleHideStopRequests,
      setCursor,
    }) => {
      if (!userLoadStatus) {
        list('account/user', 'user_name')
      }

      const [anchorEl, setAnchorEl] = useState(null)
      const [isFocused, setIsFocused] = useState(false)
      const [searching, setSearching] = useState(false)

      const handleClick = event => {
        setAnchorEl(event.currentTarget)
        setTimeout(() => {
          setIsFocused(true)
          setSearching(true)
        }, 100)
      }

      const handleClose = () => {
        setAnchorEl(null)
        setSearching(false)
      }

      const recursiveList = returnedCursor => {
        if (returnedCursor) {
          return listInbox({
            infiniteLoader: true,
            recursive: true,
            endpoint: conversationsListFilter,
          }).then(payload => recursiveList(payload?.cursor))
        } else {
          setLoadingAll(false)
          return
        }
      }

      return (
        <div className={classes.searchBox}>
          <Tooltip title="Search and filter">
            <IconButton
              classes={{ root: classes.iconButtonRoot }}
              className={classes.searchIcon}
              onClick={handleClick}
            >
              <Search />
            </IconButton>
          </Tooltip>
          <Menu
            id="conversations-list-filtering-options-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            classes={{ paper: classes.paper }}
          >
            <div style={{ width: '100%', position: 'relative' }}>
              <IconButton
                // classes={{ root: classes.iconButtonRoot }}
                style={{ position: 'absolute', top: 16, right: 6, padding: 6 }}
                className={classes.moreIconButton}
                onClick={() => {
                  handleClose()
                  // setSearching(false)
                  setIsFocused(false)
                  searchConversationsList('')
                }}
              >
                <Cancel />
              </IconButton>
              {searching ? (
                <input
                  autoFocus
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                  value={value}
                  onChange={e => {
                    if (
                      e?.target?.value &&
                      !loadingAllConversations &&
                      cursor
                    ) {
                      setLoadingAll(true)
                      recursiveList(true)
                    }
                    searchConversationsList(e?.target?.value)
                  }}
                  className={classes.input}
                  style={{
                    fontSize: 21,
                    border: 'none',
                    width: '100%',
                    borderBottom: '1px solid #ccc',
                    outline: 'none',
                    transition: 'border-color 0.2s',
                    paddingTop: 5,
                    paddingBottom: 5,
                    paddingLeft: 12,
                    paddingRight: 47,
                  }}
                  type="text"
                  placeholder="Search conversations"
                />
              ) : null}
              <span
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  height: '2px',
                  width: isFocused ? '100%' : '0',
                  backgroundColor: '#014c94',
                  transition: 'width 0.2s',
                }}
              />
            </div>
            <div
              style={{
                maxHeight: 235,
                overflowY: 'auto',
                marginTop: 15,
                position: 'relative',
              }}
            >
              {(vr_role === 'acctowner' || read_contacts === 'anybody') && (
                <>
                  <div style={{ paddingLeft: 10 }}>Filter by assigned user</div>
                  <div style={{ padding: '4px 12px 0px' }}>
                    <RadioGroup
                      aria-label="VastInboxUserFilters"
                      name="vastinboxuserfilters"
                      className={classes.group}
                      value={conversationsListUserFilter}
                      onChange={e => {
                        handleClose()
                        return create({
                          entityType: 'inboxuserfilter',
                          entity: {
                            id: `inboxuserfilter-${username}-${vr_account_id}`,
                            preference: e?.target?.value,
                          },
                          url: `${DATA_API_URL}/inboxuserfilter`,
                          hasSchema: false,
                          snackbarMessage: 'none',
                        })
                          .then(() => setCursor('', conversationsListFilter))
                          .then(() =>
                            listInbox({
                              infiniteLoader: false,
                              endpoint: conversationsListFilter,
                            }),
                          )
                      }}
                    >
                      <FormControlLabel
                        value={username}
                        control={<Radio />}
                        label="Me"
                      />
                      <FormControlLabel
                        value="all"
                        control={<Radio />}
                        label="All users"
                      />
                      <FormControlLabel
                        value="unassigned"
                        control={<Radio />}
                        label="Unassigned"
                      />
                      {Object.values(users || {})
                        .filter(user => user.user_name !== username)
                        .map(user => (
                          <FormControlLabel
                            value={user.user_name}
                            control={<Radio />}
                            label={`${
                              user.first_name ? `${user.first_name}` : ''
                            } ${user.last_name ? `${user.last_name}` : ''}`}
                          />
                        ))}
                    </RadioGroup>
                  </div>
                </>
              )}
              <div style={{ padding: '0 13px' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={hideStopRequests}
                      onChange={e => toggleHideStopRequests(e?.target?.checked)}
                    />
                  }
                  label="Hide stop requests"
                />
              </div>
            </div>
            <div style={{ position: 'absolute', bottom: 12, right: 8 }}>
              <Button onClick={handleClose}>Close</Button>
            </div>
          </Menu>
          <div
            style={{
              position: 'absolute',
              left: 57,
              top: '50%',
              transform: 'translate(0, -50%)',
              width: 'calc(100% - 63px)',
            }}
          >
            <ConversationsListTabs />
          </div>
          {/* <Tooltip title="New message">
            {loadingAllConversations ? (
              <div className={classes.moreIconButton}>
                <CircularProgress />
              </div>
            ) : (
              <IconButton
                classes={{ root: classes.iconButtonRoot }}
                className={classes.moreIconButton}
                onClick={() =>
                  toggleDialog({
                    open: true,
                    dialog: 'contactList',
                    options: {
                      type: 'inbox',
                    },
                  })
                }
              >
                <PencilPlus />
              </IconButton>
            )}
          </Tooltip> */}
        </div>
      )
    },
  ),
)
